import * as React from 'react';
import { guestVMsResponseViewModel } from '../models/views/guestVMsResponseViewModel';
import { guestVMsResponseDto } from '../models/dto/guestVMsResponseDto';
import VMContext from './VMContext';
import { virtualGuestVMsResponseTransformer } from '../models/transformers/virtualGuestVMsResponseTransformer';
import GuestVMsTableView from './GuestVMsTableView';
import styled from '@emotion/styled';

interface State {
    data: guestVMsResponseViewModel;
    noData: boolean;
}
const TableView = styled.div`
  background: #fff;
  display: block;
  font-size: 1.2rem;
`;

class GuestVMs extends React.Component {
    state = {
        data: {},
        noData: false
    } as State;

    LoadDataFromAPI = async () => {
        var id = (window as any).Dpack.Project.Id;
        const response = await fetch(`/api/opticalprime/${id}/virtualtable`);
        if (response.ok) {
            const json = await response.json();
            const data = virtualGuestVMsResponseTransformer.from(
                json.virtualGuestVMTable as guestVMsResponseDto
            );
            this.setState({ data: data });
        }
    };

    async componentDidMount() {
        await this.LoadDataFromAPI();
    }

    render() {
        RegisterRecalculationEvent(this.LoadDataFromAPI);

        return (
            <TableView>
                <VMContext.Provider value={this.state.data.runningVMs}>
                    <GuestVMsTableView data={this.state.data.guestVMsTable} />
                </VMContext.Provider>
            </TableView>
        );
    }
}

const RegisterRecalculationEvent = (callback: Function) => {
    const recalculateFlag = { val: 0 };

    (window as any).recalculateVirtualTabTableProxy = new Proxy(recalculateFlag, {
        set: () => {
            callback();
            return true;
        }
    });
};

export default GuestVMs;
